// Persist how the logistics board's Delivered column reads: one card per
// DELIVERY (the default — the column then looks like every other column) or
// one stack per MATERIAL with that material's order history and total. A
// single global preference (not per site — it is about how the person reads
// the column, not about a site's data), stored as the view's name. Guarded
// like stickyGroupsPref so a blocked or unavailable localStorage (private
// mode, SSR) silently falls back to the default instead of throwing.
export type DeliveredView = 'delivery' | 'material';

const KEY = 'dorca_logistics_delivered_view';

export function readDeliveredViewPref(): DeliveredView {
  try { return localStorage.getItem(KEY) === 'material' ? 'material' : 'delivery'; } catch { return 'delivery'; }
}

export function writeDeliveredViewPref(value: DeliveredView): void {
  try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
}
